import {i18n} from "../i18n";

export default class Helper {

    /**
     * Prevent returning an empty String to the Vue
     *
     * @param param - The String we want to check
     * @returns {*}
     */
    static preventEmptyString(param) {
        let string = param.toString();
        return string === null ? string : "";
    }

    /**
     * Retrieve date formatted in this way
     * MM/DD/YYYY and minus the loop from "fetchGraphData"
     *
     * @param parameter
     * @returns {string}
     */
    static retrieveDate(parameter) {
        return new Date(new Date().setDate(new Date().getDate() - parameter))
            .toLocaleDateString("en-US")
            .replace(/\//g, '-');
    }

    /**
     * Copy profileUrl to the clipboard
     *
     * @param profileLink (URL)
     */
    static copyUserProfileUrl(profileLink) {

        navigator.clipboard.writeText(profileLink).then(function() {
            swal.fire(
                i18n.t("dashboard.aside.success_copied_profile_url_title"),
                i18n.t("dashboard.aside.success_copied_profile_url_content", {'url': profileLink } ),
                "success"
            );
        }, function(err) {
            swal.fire(
                i18n.t("dashboard.aside.error_copied_profile_url_title"),
                i18n.t("dashboard.aside.error_copied_profile_url_title"),
                "error"
            );
        });

    }

    /**
     * Copy network to the clipboard
     *
     * @param networkName (String)
     * @param networkValue (String)
     */
    static copyNetworkToClipboard(networkName, networkValue) {

        navigator.clipboard.writeText(networkValue).then(function() {
            swal.fire(
                i18n.t("profile.success_copied_network_title"),
                i18n.t("profile.success_copied_network_content", {'networkName': networkName, 'networkValue': networkValue} ),
                "success"
            );
        }, function(err) {
            swal.fire(
                i18n.t("profile.erroor_copied_network_title"),
                i18n.t("profile.erroor_copied_network_content", {'networkName': networkName, 'networkValue': networkValue} ),
                "error"
            );
        });

    }

}


// WEBPACK FOOTER //
// ./src/helpers/helpers.js